import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { getCountries, getLanguages } from 'api/Languages';

export const fetchLanguages = createAsyncThunk(
    'fetchLanguages',
    async () => {
        const response = await getLanguages();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            // @ts-ignore
            const { languages } = getState().languageState;
            if (languages.length) return false;
        },
    },
);

export const fetchCountries = createAsyncThunk(
    'fetchCountries',
    async () => {
        const response = await getCountries();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            // @ts-ignore
            const { countries } = getState().languageState;
            if (countries.length) return false;
        },
    },
);

const languageKey = 'language';
const countryKey = 'country';

// const initialLanguage = localStorage.getItem(languageKey)
//     ? JSON.parse(localStorage.getItem(languageKey))
//     : localStorage.setItem(
//           languageKey,
//           JSON.stringify({
//               name: 'English',
//               icon: null,
//               code: 'en',
//           }),
//       );
// const initialCountry = localStorage.getItem(countryKey)
//     ? JSON.parse(localStorage.getItem(countryKey))
//     : localStorage.setItem(
//           countryKey,
//           JSON.stringify({
//               name: 'England',
//               icon: null,
//               code: 'en',
//           }),
//       );
const languageSlice = createSlice({
    name: 'languageSlice',
    initialState: {
        language: {},
        country: {},
        languages: [],
        countries: [],
    },
    reducers: {
        changeLanguage: (state, action) => {
            state.language = action.payload;
            localStorage.setItem(languageKey, JSON.stringify(action.payload));
        },
        changeCountry: (state, action) => {
            state.country = action.payload;
            localStorage.setItem(countryKey, JSON.stringify(action.payload));
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchLanguages.fulfilled, (state, action) => {
            state.languages = action.payload.data;
            if (localStorage.getItem(languageKey)) {
                state.language = JSON.parse(localStorage.getItem(languageKey));
            } else {
                localStorage.setItem(languageKey, JSON.stringify(action.payload.data[0]));
                state.language = action.payload.data[0];
            }
        });
        builder.addCase(fetchCountries.fulfilled, (state, action) => {
            state.countries = action.payload.data;
            if (localStorage.getItem(countryKey)) {
                state.country = JSON.parse(localStorage.getItem(countryKey));
            } else {
                localStorage.setItem(countryKey, JSON.stringify(action.payload.data[0]));
                state.country = action.payload.data[0];
            }
        });
    },
});

export const selectLanguageState = createSelector([state => state.languageState], data => data || {});

export const selectCurrentCountry = createSelector(
    [state => state.languageState],
    languageState => languageState.country,
);
export const selectCurrentLanguage = createSelector(
    [state => state.languageState],
    languageState => languageState.language,
);

export const selectActiveLanguageAndContry = createSelector(
    [selectCurrentCountry, selectCurrentLanguage],
    (country, language) => ({
        country,
        language,
    }),
);

export const selectCoutriesOptionsForFilter = createSelector([state => state.languageState.countries], data =>
    data.map(country => ({
        name: country.name,
        value: country.code,
    })),
);

export const { changeLanguage, changeCountry } = languageSlice.actions;

export default languageSlice.reducer;
